<template>
	<div id="app" v-if="isShow">
		<transition name="router-fade" mode="out-in">
			<keep-alive include="NewHome">
				<router-view />
			</keep-alive>
		</transition>
		<div class="mask_wx" v-if="isWx">
			<img src="./images/mask_wx.png" alt="" />
		</div>

		<!-- 新人专享 -->
		<draggable
			v-if="isShowNewUser && isShowPath && isShowHostName && isShowCouponPop"
			:initialPosition="{ bottom: 2.58, right: 0, unit: 'rem' }"
			@click="goNewPeopleActivity"
		>
			<div class="new-small-box">
				<img class="new-man-small" src="~@/images/gameHome/lucky.png" alt="" />
				<div class="new-small-text">
					{{ message }}
					<img src="~@/images/gameHome/path.png" alt="" class="new-small-path" />
				</div>
			</div>
		</draggable>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { QueryString } from './js/common';
import { PROXY_URL } from './config/env';
import { NEW_HOME_DOMAIN_NAME } from './config/constants';
import {
	GetNotifyKey,
	getConfigPrize,
	getHomeAdConfig,
	getMyCouponList,
	QueryBindChannelStore
} from './service/getData';
import Draggable from '@/components/draggable.vue';
import { callHandler } from '../src/js/jsBridge';
export default {
	name: 'App',
	data() {
		return {
			isWx: false,
			isShowPath: false,
			isShowHostName: false,
			message: '',
			activity: {},
			list: {},
			pagTime: '',
			timer: null,
			timerD: null,
			seconds: 86400,
			hongbao: '',
			expireTime: '',
			time: 0,
			isShow: false
		};
	},
	components: {
		Draggable
	},
	watch: {
		$route(to, from) {
			// 滚动兼容问题修复
			if (NEW_HOME_DOMAIN_NAME.includes(window.location.host) && ['/'].includes(to.path)) {
				document.querySelector('body').setAttribute('style', 'overflow: hidden;');
				if (document.querySelector('#app')) {
					document.querySelector('#app').setAttribute('style', 'overflow: hidden;');
				}
			} else {
				document.querySelector('body').setAttribute('style', 'overflow: auto;');
				if (document.querySelector('#app')) {
					document.querySelector('#app').setAttribute('style', 'overflow: auto;');
				}
			}
		},
		// 登录状态刷新之后需要重新获取信任弹窗信息
		async userInfo() {
			setTimeout(async () => {
				await this.getMyCouponList();
				await this.getHomeAdConfig();
				await this.getConfigPrize();
			}, 500);
			this.changeMessage();
			if (!(this.$store.state.userInfo && this.$store.state.userInfo.authorization)) {
				window.localStorage.removeItem('times');
				window.localStorage.removeItem('examTime');
			}
		}
	},
	computed: {
		...mapState(['isShowNewUser', 'userInfo']),
		isShowCouponPop() {
			if (['/', '/goodslist', '/goodsdetail'].includes(this.$route.path)) {
				return true;
			}
			return false;
		}
	},
	async created() {
		let channel = this.getUrl('channel') || '';
		let virtualPrefix = '';
		if (channel) {
			let ary = channel.split('_'); // 如果找到下划线，则截取下划线之前的字符串，否则返回原字符串
			virtualPrefix = ary[0];
		}

		await QueryBindChannelStore({
			virtualPrefix
		})
			.then(({ data }) => {
				if (data.result.channel) {
					this.$store.commit('setBusinessNo', data.result.channel);
					this.$store.commit('setChannel', data.result.channel);
					this.$store.commit('setVirtualChannel', channel);
					sessionStorage.setItem('businessNo', data.result.channel);
					sessionStorage.setItem('channel', data.result.channel);
					sessionStorage.setItem('virtualChannel', channel);
					this.isShow = true;
				} else {
					this.updateChannel();
					this.isShow = true;
				}
			})
			.catch(() => {
				this.updateChannel();
				this.isShow = true;
			});
		// 判断那些域名显示新人浮窗
		if (NEW_HOME_DOMAIN_NAME.includes(window.location.host)) {
			this.isShowHostName = true;
		} else {
			this.isShowHostName = false;
		}
		// 接口获取是否展示新人活动
		await this.getConfigPrize();
	},
	async mounted() {
		this.$EventBus.$on('initCoupon', this.initCoupon);
		let channel = this.getUrl('channel') || '';
		let shq = this.getUrl('shq') || '';
		if (channel.indexOf('zhwk') > -1) {
			localStorage.setItem('zhwk', true);
		}
		if (shq) {
			localStorage.setItem('shq', true);
		}
		this.maskWx();
		this.isMobile();
		// const bd_vid = QueryString("bd_vid") || this.getUrl("bd_vid");
		// const sg_vid = QueryString("bd_vid") || this.getUrl("sg_vid");
		// const qhclickid = QueryString("bd_vid") || this.getUrl("qhclickid");
		const ttclick = QueryString('adid') || this.getUrl('adid'); // 头条
		GetNotifyKey({
			businessNo: QueryString('channel') || this.getUrl('channel') || this.$store.state.businessNo
		}).then((res) => {
			let vid = res.data.result;
			let vidValue = QueryString(vid) || this.getUrl(vid);
			if (ttclick) {
				// 头条存储location.href
				if (QueryString(vid)) {
					// query
					let href = decodeURIComponent(window.location.href.replace(location.hash, ''));
					sessionStorage.setItem('ttclick', href);
				} else if (this.getUrl(vid)) {
					// 如果拼在hash值后面
					let arr = window.location.href.split('?');
					let href = decodeURIComponent(window.location.href.replace(location.hash, ''));
					sessionStorage.setItem('ttclick', `${location.origin}?${arr[arr.length - 1]}`);
				}
				return false;
			}
			sessionStorage.setItem(vid, vidValue);
		});
		// if (bd_vid) {
		//   sessionStorage.setItem("bd_vid", bd_vid);
		// }
		// if (sg_vid) {
		//   sessionStorage.setItem("sg_vid", sg_vid);
		// }
		// if (qhclickid) {
		//   sessionStorage.setItem("qhclickid", qhclickid);
		// }
		// if (ttclick) {
		//   // 头条存储location.href
		//   if (QueryString("adid")) {
		//     // query
		//     let href = decodeURIComponent(
		//       window.location.href.replace(location.hash, "")
		//     );
		//     sessionStorage.setItem("ttclick", href);
		//   } else if (this.getUrl("adid")) {
		//     // 如果拼在hash值后面
		//     let arr = window.location.href.split("?");
		//     let href = decodeURIComponent(
		//       window.location.href.replace(location.hash, "")
		//     );
		//     sessionStorage.setItem(
		//       "ttclick",
		//       `${location.origin}?${arr[arr.length - 1]}`
		//     );
		//   }
		// }
		channel && localStorage.setItem('channel', channel);

		const initiatorId = this.getUrl('initiatorId') || '';
		const assistModeType = this.getUrl('assistModeType') || '';
		if (initiatorId) {
			sessionStorage.setItem('initiatorId', initiatorId);
			sessionStorage.setItem('assistModeType', assistModeType);
		}

		let that = this;
		window['goRightPage'] = function () {
			that.goRightPage();
		};
		//获取红包列表
		try {
			if (this.$store.state.userInfo && this.$store.state.userInfo.authorization) {
				await this.getMyCouponList();
			} else {
				window.localStorage.removeItem('times');
				window.localStorage.removeItem('examTime');
			}
			await this.getHomeAdConfig();
			if (this.isShowPath) {
				this.changeMessage();
			}
		} catch (error) {}

		// 设置 vid_notify_href
		let notifyHref = `${window.location.href}`;
		sessionStorage.setItem('vid_notify_href', notifyHref);
	},
	methods: {
		updateChannel() {
			let channel = this.getUrl('channel') || '';
			let newChannel = 'android_xubeimH5';

			if (channel) {
				switch (channel) {
					case 'fengqun':
						newChannel = 'Android_mtf_fengqun';
						break;
					case 'xubeiwb1':
						newChannel = 'Android_mtf_xubeiwb1';
						break;
					case 'xubeiwb2':
						newChannel = 'Android_mtf_xubeiwb2';
						break;
					case 'xubeiwb3':
						newChannel = 'Android_mtf_xubeiwb3';
						break;
					case 'xubeiwb4':
						newChannel = 'Android_mtf_xubeiwb4';
						break;
					case 'xubeiwb5':
						newChannel = 'Android_mtf_xubeiwb5';
						break;
					default:
						break;
				}

				sessionStorage.setItem('newChannel', newChannel);
				sessionStorage.setItem('channel', channel);
				this.$store.commit('setChannel', channel);
			}
		},
		getUrl(name) {
			let url = window.location.href;
			var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
			var r = !url.split('?')[1] ? '' : url.split('?')[1].match(reg);
			if (!!r) return decodeURI(r[2]);
			return null;
		},
		isMobile() {
			let mobile = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			);
			let url = window.location.href.indexOf('complaint_advice') > -1;
			if (!mobile && url) {
				window.location.href = `http://user.${PROXY_URL.domain}/complaint_advice`;
			}
		},
		maskWx() {
			let ua = navigator.userAgent.toLowerCase();
			let isWeixin = ua.indexOf('micromessenger') != -1;
			// if (isWeixin) {
			//   this.isWx = true;
			// }
		},
		goRightPage(orderNo) {
			window.location.href = `http://m.${PROXY_URL.domain}/#/rightsProblem?orderNo=${orderNo}`;
		},
		goRightPage(orderNo) {
			window.location.href = `http://m.${PROXY_URL.domain}/#/rightsProblem?orderNo=${orderNo}`;
		},
		// 获取新人专享
		async getConfigPrize() {
			// 用户未登录
			if (!(this.$store.state.userInfo && this.$store.state.userInfo.authorization)) {
				this.$store.commit('setIsShowNewUser', true);
				return false;
			}
			// 用户已登录
			let params = {
				Authorization: this.$store.state.userInfo.authorization,
				appChannel: this.$route.query.channel || this.$store.state.businessNo
			};
			const { data } = await getConfigPrize(params);
			if (data.code == '1' && data.success) {
				if (data.result.userType == 10 || data.result.userType == 11) {
					this.$store.commit('setIsShowNewUser', true);
				} else {
					this.$store.commit('setIsShowNewUser', false);
				}
			}
		},
		//新人浮窗
		async getHomeAdConfig() {
			let params = { adEnter: 1, clientType: 1 };
			const { data } = await getHomeAdConfig(params);
			this.activity = data.result;
			// 判断当前路由是否显示新人浮窗
			if (NEW_HOME_DOMAIN_NAME.includes(window.location.host)) {
				if (!(this.$store.state.userInfo && this.$store.state.userInfo.authorization)) {
					this.isShowPath = true;
				} else if (
					Object.keys(this.list).length &&
					this.activity &&
					this.activity.floatAd &&
					this.activity.coupon &&
					this.activity.floatAd.activityType == 10 &&
					this.activity.floatAd.userType == 10 &&
					(this.activity.coupon.status == 1 ||
						(this.activity.coupon.status == 2 && this.list.usable.size !== 0))
				) {
					// 新人活动 = 10 && 新人用户 = 10 && (券状态是未领取1 || 已领取 未使用2)
					this.isShowPath = true;
				} else {
					this.isShowPath = false;
				}
			} else {
				this.isShowPath = false;
			}
			// this.expireTime = data.result.coupon.expireTime
		},
		//获取红包列表
		async getMyCouponList() {
			let params = {
				activityType: 1,
				businessNo: QueryString('channel') || this.getUrl('channel') || this.$store.state.businessNo
			};
			const { data } = await getMyCouponList(params);
			this.list = data.result;
			this.expireTime =
				data.result.usable &&
				data.result.usable.coupons.length != 0 &&
				data.result.usable.coupons[0].couponEndTime;
		},
		// 点击新人浮窗
		async goNewPeopleActivity() {
			if (!(this.$store.state.userInfo && this.$store.state.userInfo.authorization)) {
				this.$router.push({
					path: '/login',
					query: {
						redirect: `/welfare?channel=${
							localStorage.getItem('channel') || this.$store.state.businessNo
						}&clientId=6`
					}
				});
				return false;
			}
			this.$router.push({
				path: '/welfare',
				query: {
					channel: QueryString('channel') || this.getUrl('channel') || this.$store.state.businessNo,
					clientId: 6
				}
			});
		},
		countDown() {
			window.localStorage.setItem('examTime', this.seconds);
			let time = window.localStorage.getItem('times');
			if (time != null && time >= 0) this.seconds = parseInt(time);
			let h = parseInt((this.seconds / (60 * 60)) % 24);
			h = h < 10 ? '0' + h : h;
			let m = parseInt((this.seconds / 60) % 60);
			m = m < 10 ? '0' + m : m;
			let s = parseInt(this.seconds % 60);
			s = s < 10 ? '0' + s : s;
			this.pagTime = h + ':' + m + ':' + s;
			// this.activity.coupon.status == 2
			this.message = '活动有效期' + this.pagTime;
		},
		startTime() {
			window.clearInterval(this.timer);
			this.countDown();
			this.timer = setInterval(() => {
				this.seconds -= 1;
				if (this.seconds == 0) {
					window.localStorage.removeItem('times');
					window.localStorage.removeItem('examTime');
				}
				window.localStorage.setItem('times', this.seconds);
				this.countDown();
			}, 1000);
		},
		countDownDay() {
			let now = +new Date();
			let end = +new Date(this.expireTime);
			this.time = (end - now) / 1000;
			let d = Math.floor(this.time / (60 * 60 * 24));
			d = d < 10 ? '0' + d : d;
			let h = parseInt((this.time / (60 * 60)) % 24);
			h = h < 10 ? '0' + h : h;
			let m = parseInt((this.time / 60) % 60);
			m = m < 10 ? '0' + m : m;
			let s = parseInt(this.time % 60);
			s = s < 10 ? '0' + s : s;
			this.hongbao = this.time > 86400 ? d + '天' + h + ':' + m + ':' + s : h + ':' + m + ':' + s;
			this.message = '距红包失效还有' + this.hongbao;
		},
		startTimeDay() {
			this.timerD && window.clearInterval(this.timerD);
			this.countDownDay();
			this.timerD = setInterval(() => {
				// this.expireTime -= 1000;
				if (this.time < 0) {
					window.clearInterval(this.timerD);
					this.isShowPath = false;
				}
				this.countDownDay();
			}, 1000);
		},
		changeMessage() {
			// if (!this.isShowPath) {
			//   return
			// }
			//判断弹窗内时间文字
			window.clearInterval(this.timer);
			window.clearInterval(this.timerD);
			if (
				(this.activity && !(this.$store.state.userInfo && this.$store.state.userInfo.authorization)) ||
				(this.$store.state.userInfo.newUser &&
					this.$store.state.userInfo.authorization &&
					this.activity.coupon.status == 1)
			) {
				// sessionStorage.setItem('examTime',this.seconds)
				this.startTime();
				// this.message = '活动有效期' + this.pagTime
			} else if (
				(this.activity && this.activity.floatAd.userType == 10 && this.activity.coupon.status == 2) ||
				(this.activity.floatAd.activityType == 10 &&
					this.activity.floatAd.userType == 10 &&
					this.list.usable &&
					this.list.usable.size !== 0)
			) {
				// this.startTime()
				this.startTimeDay();
			}
		},
		async initCoupon() {
			await this.getMyCouponList();
			await this.getHomeAdConfig();
			this.changeMessage();
		}
	}
};
</script>

<style lang="scss">
@import './style/reset';

// 引入阿里icon
@font-face {
	font-family: 'iconfont';
	/* project id 252520 */
	src: url('//at.alicdn.com/t/font_252520_bl2ny27ff54.eot');
	src: url('//at.alicdn.com/t/font_252520_bl2ny27ff54.eot?#iefix') format('embedded-opentype'),
		url('//at.alicdn.com/t/font_252520_bl2ny27ff54.woff') format('woff'),
		url('//at.alicdn.com/t/font_252520_bl2ny27ff54.ttf') format('truetype'),
		url('//at.alicdn.com/t/font_252520_bl2ny27ff54.svg#iconfont') format('svg');
}

#app {
	.mask_wx {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9999;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.94);
		overflow: hidden;

		img {
			display: block;
			width: px2rem(750rem);
			height: px2rem(270rem);
			margin: 0.12rem auto;
		}
	}
}

.router-fade-enter-active,
.router-fade-leave-active {
	transition: opacity 0.1s;
}

.router-fade-enter,
.router-fade-leave-active {
	opacity: 0;
}

.new-small-box {
	position: relative;
	padding: 0.06rem 0.2rem 0.14rem 0.24rem;
	width: 2rem;
	height: 1.84rem;

	.new-man-small {
		margin: 0 auto;
		width: 1.56rem;
		height: 1.64rem;
	}

	.new-small-text {
		// margin-top: -0.5rem;
		position: absolute;
		left: 50%;
		bottom: 0;
		transform: translateX(-50%);
		padding: 0.04rem 0.3rem;
		width: 2.04rem;
		height: 0.64rem;
		background: url(~@/images/gameHome/bg.png) no-repeat center center;
		background-size: 100%;
		font-weight: 500;
		font-size: 0.2rem;
		color: #ffffff;
		line-height: 0.28rem;
		text-align: center;
		font-style: normal;

		.new-small-path {
			position: absolute;
			right: 0.14rem;
			top: 50%;
			transform: translateY(-50%);
			width: 0.1rem;
			height: 0.16rem;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/App.vue